import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		edit: {
			panel: {
				// height: '280px',
				width: '80%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		list: {
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		select: {
			panel: {
				width: '70%',
				height: '500px'
			},
			config: {
				fields: {
					id: {
					},
					owner: {
					},
					date_inspections: {
					},
					inspections_type: {
					},
					p1: {
					},
					p2: {
					},
					p3: {
					},
					p4: {
					},
					p5: {
					},
					p6: {
					},
					diary: {},
					doctor: {
					},
					main_doctor: {
					},
					logoped: {}
				}
			}
		}
	}
}